interface DialogTitleBarProps {
    title: string
    backgroundColor?: string
}
const DialogTitleBar = ({title, backgroundColor}: DialogTitleBarProps) => {
    return (
        <div>
            <span className="fcBlack fm-c ls06 fs19">{title}</span>
        </div>
    )
}
export default DialogTitleBar;